<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {CtaSlice} from '@prismicio-types';
    import CtaDefault from './variations/CtaDefault.vue';
    import CtaWithProfile from './variations/CtaWithProfile.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<CtaSlice>());

    const variationComponents = {
        default: CtaDefault,
        ctaWithProfile: CtaWithProfile,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-cta {
        width: 100%;
        font-family: var(--joy-font-family-base);

        &--hide-in-mobile {
            display: none;

            @include mq.screen_sm(min) {
                display: block;
            }
        }
    }
</style>
